import { useConfig } from "./useConfig";
import { UserDataDisplayConfig } from "@kaltura/mediaspace-shared-types";

/**
 * custom hook to get config values for userDataDisplay
 * controls whether to show user email and id
 */
export const useUserDataDisplay = () => {
    const context = useConfig();
    const { userDataDisplay } = context.application;
    const showEmail = userDataDisplay.includes(UserDataDisplayConfig.email);
    const showId = userDataDisplay.includes(UserDataDisplayConfig.id);

    return { showEmail, showId };
};
